import React from 'react';

import {ABV} from './Icons/ABV';
import ActiveUsers from './Icons/ActiveUsers';
import Beer from './Icons/Beer';
import BeerDashboard from './Icons/BeerDashboard';
import BeerPouring1 from './Icons/BeerPouring1';
import BeerPouring2 from './Icons/BeerPouring2';
import BeerPouring3 from './Icons/BeerPouring3';
import BeerPouring4 from './Icons/BeerPouring4';
import BeerPouring5 from './Icons/BeerPouring5';
import BeerPouring6 from './Icons/BeerPouring6';
import Beers1 from './Icons/Beers1';
import Beers2 from './Icons/Beers2';
import {BeersPlaceholder} from './Icons/BeersPlaceholder';
import BeerStyles from './Icons/BeerStyles';
import {BeersZeroState} from './Icons/BeersZeroState';
import Breweries from './Icons/Breweries';
import Camera from './Icons/Camera';
import CenterAlign from './Icons/CenterAlign';
import Check from './Icons/Check';
import ChevronDoubleLeft from './Icons/ChevronDoubleLeft';
import ChevronDoubleRight from './Icons/ChevronDoubleRight';
import ChevronDown from './Icons/ChevronDown';
import ChevronLeft from './Icons/ChevronLeft';
import ChevronRight from './Icons/ChevronRight';
import Close from './Icons/Close';
import {CloseModal} from './Icons/CloseModal';
import {ContactAddress} from './Icons/ContactAddress';
import Dashboard from './Icons/Dashboard';
import Delete from './Icons/Delete';
import Download from './Icons/Download';
import Drag from './Icons/Drag';
import {DropdownClose} from './Icons/DropdownClose';
import Edit from './Icons/Edit';
import {EditRound} from './Icons/EditRound';
import Email from './Icons/Email';
import Facebook from './Icons/Facebook';
import {FbIcon} from './Icons/FbIcon';
import Filter from './Icons/Filter';
import {FlagZero} from './Icons/FlagZero';
import {ForgotPasswordLock} from './Icons/ForgotPasswordLock';
import {IBU} from './Icons/IBU';
import ImagePlaceholder from './Icons/ImagePlaceholder';
import Info from './Icons/Info';
import Instagram from './Icons/Instagram';
import InstagramLink from './Icons/instagram-link';
import InstagramSolid from './Icons/InstagramSolid';
import InstagramWhite from './Icons/instagramWhite';
import Key from './Icons/Key';
import LeftAlign from './Icons/LeftAlign';
import Location from './Icons/Location';
import Lock from './Icons/Lock';
import {LoginLogo} from './Icons/LoginLogo';
import Logo from './Icons/Logo';
import LogoAlt from './Icons/LogoAlt';
import Logout from './Icons/Logout';
import {LogoutConfirmation} from './Icons/LogoutConfirmation';
import MobileMenu from './Icons/MobileMenu';
import {NewPost} from './Icons/NewPost';
import Pencil from './Icons/Pencil';
import {PersonContact} from './Icons/PersonContact';
import Phone from './Icons/Phone';
import Plus from './Icons/Plus';
import PlusCircleBold from './Icons/PlusCircleBold';
import PostArchives from './Icons/PostArchive';
import {PubPageImagePlaceholder} from './Icons/PubPageImagePlaceholder';
import Pubs from './Icons/Pubs';
import PubTV from './Icons/PubTV';
import RightAlign from './Icons/RightAlign';
import Search from './Icons/Search';
import SelectedPub from './Icons/SelectedPub';
import Settings from './Icons/Settings';
import Sort2 from './Icons/Sort2';
import SortDown from './Icons/SortDown';
import {StepBack} from './Icons/StepBack';
import SwitchAccount2 from './Icons/SwitchAccount2';
import SwitchAccount3 from './Icons/SwitchAccount3';
import Triangle from './Icons/Triangle';
import {TVIcon} from './Icons/TVIcon';
import User1 from './Icons/User1';
import {User2} from './Icons/User2';
import User3 from './Icons/User3';
import User4 from './Icons/User4';
import User5 from './Icons/User5';
import User5Active from './Icons/User5Active';
import Users from './Icons/Users';
import Web from './Icons/Web';

const ProfilePlaceholder = React.lazy(() => import('./Icons/ProfilePlaceholder'));

const BreweriesImagePlaceholder = React.lazy(() =>
  import('./Icons/BreweriesImagePlaceholder').then((mod) => {
    return {default: mod.BreweriesImagePlaceholder};
  }),
);

const BeersImagePlaceholder = React.lazy(() =>
  import('./Icons/BeersImagePlaceholder').then((mod) => {
    return {default: mod.BeersImagePlaceholder};
  }),
);

const EmptyTap = React.lazy(() => import('./Icons/EmptyTap'));
const BeersTap = React.lazy(() => import('./Icons/BeersTap'));
const PouringMachines = React.lazy(() => import('./Icons/PouringMachines'));

export const iconObject: {[key: string]: JSX.Element} = {
  'active-users': <ActiveUsers />,
  'beer-dashboard': <BeerDashboard />,
  beer: <Beer />,
  'beers-1': <Beers1 />,
  'beers-2': <Beers2 />,
  'beer-styles': <BeerStyles />,
  breweries: <Breweries />,
  camera: <Camera />,
  'chevron-down': <ChevronDown />,
  'chevron-left': <ChevronLeft />,
  'chevron-right': <ChevronRight />,
  'chevron-double-left': <ChevronDoubleLeft />,
  'chevron-double-right': <ChevronDoubleRight />,
  close: <Close />,
  dashboard: <Dashboard />,
  delete: <Delete />,
  edit: <Edit />,
  email: <Email />,
  facebook: <Facebook />,
  instagram: <Instagram />,
  instagramWhite: <InstagramWhite />,
  filter: <Filter />,
  info: <Info />,
  key: <Key />,
  location: <Location />,
  lock: <Lock />,
  logout: <Logout />,
  'mobile-menu': <MobileMenu />,
  phone: <Phone />,
  'post-archives': <PostArchives />,
  pubs: <Pubs />,
  search: <Search />,
  settings: <Settings />,
  'sort-2': <Sort2 />,
  'sort-down': <SortDown />,
  'switch-account-2': <SwitchAccount2 />,
  'switch-account-3': <SwitchAccount3 />,
  'user-1': <User1 />,
  'user-2': <User2 />,
  'user-3': <User3 />,
  'user-4': <User4 />,
  'user-5': <User5 />,
  'user-5-active': <User5Active />,
  web: <Web />,
  logo: <Logo />,
  plus: <Plus />,
  'logo-alt': <LogoAlt />,
  download: <Download />,
  users: <Users />,
  login_logo: <LoginLogo />,
  drag: <Drag />,
  'plus-circle-bold': <PlusCircleBold />,
  pencil: <Pencil />,
  'new-post': <NewPost />,
  'left-align': <LeftAlign />,
  'center-align': <CenterAlign />,
  'right-align': <RightAlign />,
  'step-back': <StepBack />,
  'close-modal': <CloseModal />,
  'tv-icon': <TVIcon />,
  'fb-icon': <FbIcon />,
  'beer-placeholder': <BeersPlaceholder />,
  'flag-zero': <FlagZero />,
  'dropdown-close': <DropdownClose />,
  triangle: <Triangle />,
  'instagram-link': <InstagramLink />,
  'beers-image-placeholder': <BeersImagePlaceholder />,
  'pub_page-image-placeholder': <PubPageImagePlaceholder />,
  'breweries-image-placeholder': <BreweriesImagePlaceholder />,
  'profile-placeholder': <ProfilePlaceholder />,
  'contact-address': <ContactAddress />,
  'edit-round': <EditRound />,
  'person-contact': <PersonContact />,
  'empty-tap': <EmptyTap />,
  'beer-pouring-1': <BeerPouring1 />,
  'beer-pouring-2': <BeerPouring2 />,
  'beer-pouring-3': <BeerPouring3 />,
  'beer-pouring-4': <BeerPouring4 />,
  'beer-pouring-5': <BeerPouring5 />,
  'beer-pouring-6': <BeerPouring6 />,
  'beers-tap': <BeersTap />,
  'pouring-machines': <PouringMachines />,
  'image-placeholder': <ImagePlaceholder />,
  check: <Check />,
  'selected-pub': <SelectedPub />,
  forgot_password_lock: <ForgotPasswordLock />,
  'instagram-solid': <InstagramSolid />,
  pubtv: <PubTV />,
  beers_zero_state: <BeersZeroState />,
  abv: <ABV />,
  ibu: <IBU />,
  logout_confirmation: <LogoutConfirmation />,
};
